import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1593ae86"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "f7-icons size-22" }, "globe", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("言語")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("日本語")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("英語")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-status" }, "メールアドレスを変更しました。"),
  /*#__PURE__*/_createElementVNode("div", { class: "login-content" }, "ご登録ありがとうございました。"),
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "content-one" }, "新しいアドレス宛にに案内メールを送信しました。"),
    /*#__PURE__*/_createElementVNode("div", { class: "content-two" }, "案内メールが届きましたら、メールに記載されているURLにて宿泊者カードを登録してください。")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f7_button = _resolveComponent("f7-button")!
  const _component_f7_navbar = _resolveComponent("f7-navbar")!
  const _component_f7_actions_label = _resolveComponent("f7-actions-label")!
  const _component_f7_actions_button = _resolveComponent("f7-actions-button")!
  const _component_f7_actions_group = _resolveComponent("f7-actions-group")!
  const _component_f7_actions = _resolveComponent("f7-actions")!
  const _component_f7_page = _resolveComponent("f7-page")!

  return (_openBlock(), _createBlock(_component_f7_page, { style: {"background-color":"#FFF"} }, {
    default: _withCtx(() => [
      _createVNode(_component_f7_navbar, { title: "メールアドレスの変更" }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_button, {
            class: "col",
            raised: "",
            "actions-open": "#actions-one-group"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_f7_actions, { id: "actions-one-group" }, {
        default: _withCtx(() => [
          _createVNode(_component_f7_actions_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_f7_actions_label, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_f7_actions_button, { bold: "" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_f7_actions_button, null, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_5
    ]),
    _: 1
  }))
}